import { fetchAPI } from "lib/fetch";

export const addCustomer = async (email: string) => {
  const awsServiceUrl = `${process.env.REACT_APP_GW}/stripe/customer`;
  const awsKey = `${process.env.REACT_APP_GW_KEY}`;

  try {
    const addcustomerresp = await fetchAPI(awsServiceUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": awsKey,
      },
      data: JSON.stringify({
        email: email,
      }),
    });

    return addcustomerresp;
  } catch (error) {
    // console.log("error from stripe add Customer", error);
    return null;
  }
};

export const getPortalSession = async (customerid: string) => {
  const awsServiceUrl = `${process.env.REACT_APP_GW}/stripe/customer/portal`;
  const awsKey = `${process.env.REACT_APP_GW_KEY}`;

  try {
    const portalsession = await fetchAPI(awsServiceUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": awsKey,
      },
      data: JSON.stringify({
        customerid: customerid,
      }),
    });

    console.log("protal session", portalsession);
    return portalsession;
  } catch (error) {
    console.log("error from stripe get protal session", error);
    return null;
  }
};

export const getCheckoutSession = async (customerid: string) => {
  const awsServiceUrl = `${process.env.REACT_APP_GW}/stripe/customer/checkout`;
  const awsKey = `${process.env.REACT_APP_GW_KEY}`;

  try {
    const portalsession = await fetchAPI(awsServiceUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": awsKey,
      },
      data: JSON.stringify({
        customerid: customerid,
      }),
    });

    return portalsession;
  } catch (error) {
    // console.log("error from stripe get checkout protal session", error);
    return null;
  }
};
